import { createContext } from 'react'

const CostOptionsContext = createContext()

export default CostOptionsContext